/**
 * Created by xuyq on 2022/7/5.
 */
import { router, store, judgePermission } from '@/myops/core'

const { commit } = store

router.addRoute({
  path: '/',
  redirect: '/chatbot',
})

router.beforeEach(async (to, from, next) => {
  // const token = localStorage.getItem("auth-token")

  // console.log('=========token=========',token)
  // if(to.path && to.path !== '/anonymous' && !token){
  //   const ref = process.env.VUE_APP_REDIRECT + "anonymous"
  //   const loginUrl = `https://myopsnext.accenture.cn/login/?redirect=${btoa(ref)}&cache=y`
  //   next(false)
  //   location.replace(loginUrl)
  //   return
  // }

  if (to.matched.some(t => t.meta.anonymous)) {
    if (process.env.NODE_ENV === 'production' && to.fullPath && to.fullPath === '/login') {
      window.location.href = 'https://myops.accenture.cn/chatbot/'
    } else {
      next()
    }
  } else {
    let { bar = 'fixed', footer = 'static' } = to.meta
    commit('appConfig/UPDATE_APP_BAR_TYPE', 'static')
    commit('appConfig/UPDATE_FOOTER_TYPE', 'hidden')

    // if(!!token) {
    //   await store.dispatch('user/getUserInfo')
    // }

    // next()

    // console.log(this.$store)
    await judgePermission(to, next)
  }
})

export default router

